/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../common/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "BalanceTransactionIntent": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "totalAmount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fromPlatformAccount": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "toPlatformAccount": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "BalanceTransactionResult": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "journalEntryId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "BalanceTransactionRefund": {
                "fields": {
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refundAmount": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.common.OperationStatus",
                    "id": 3,
                    "rule": "optional"
                  },
                  "journalEntryId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "BalanceTransaction": {
                "fields": {
                  "balanceIntent": {
                    "type": "squareup.esperanto.model.BalanceTransactionIntent",
                    "id": 1,
                    "rule": "optional"
                  },
                  "balanceResult": {
                    "type": "squareup.esperanto.model.BalanceTransactionResult",
                    "id": 2,
                    "rule": "optional"
                  },
                  "balanceRefund": {
                    "type": "squareup.esperanto.model.BalanceTransactionRefund",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BalanceTransactionIntent && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BalanceTransactionResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BalanceTransactionRefund && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.BalanceTransaction) {
  $root.addJSON(jsonData);
}

/**
 * Information needed for a balance transaction between Square accounts
 *
 * SOURCE BalanceTransactionIntent @ squareup/esperanto/model/balance.proto at 13:1
 */
export const BalanceTransactionIntent = $root.lookupType('squareup.esperanto.model.BalanceTransactionIntent');
fixType(BalanceTransactionIntent);
Builder.createAndAttachToType(BalanceTransactionIntent);
/**
 * Result of a Square account balance transfer
 *
 * SOURCE BalanceTransactionResult @ squareup/esperanto/model/balance.proto at 32:1
 */
export const BalanceTransactionResult = $root.lookupType('squareup.esperanto.model.BalanceTransactionResult');
fixType(BalanceTransactionResult);
Builder.createAndAttachToType(BalanceTransactionResult);
/**
 * Result of a Square account balance transfer refund
 *
 * SOURCE BalanceTransactionRefund @ squareup/esperanto/model/balance.proto at 48:1
 */
export const BalanceTransactionRefund = $root.lookupType('squareup.esperanto.model.BalanceTransactionRefund');
fixType(BalanceTransactionRefund);
Builder.createAndAttachToType(BalanceTransactionRefund);
/**
 * Balance transfer transaction
 *
 * SOURCE BalanceTransaction @ squareup/esperanto/model/balance.proto at 69:1
 */
export const BalanceTransaction = $root.lookupType('squareup.esperanto.model.BalanceTransaction');
fixType(BalanceTransaction);
Builder.createAndAttachToType(BalanceTransaction);